import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import LikeButton from '../component/LikeButton';
import CommentsOffcanvas from '../component/CommentsOffcanvas';
import BookmarkButton from '../component/BookmarkButton';
import { Comment, Share } from '@mui/icons-material';
import { formatTimeAgo, shareTextOf } from '../utils/Universalfunctions';
import SEO, { seoConfig } from '../component/SEO';
import Loading from '../component/Loading';
import PageShapes from '../component/PageShapes';
import { ideasBatch } from '../Admin/data';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import AdminExplore from '../Admin/AdminExplore';

const Explore = ({ previewItems }) => {

     const navigate = useNavigate();

     const [problems, setProblems] = useState([]);
     const [loading, setLoading] = useState(true);
     const [showComments, setShowComments] = useState(false);
     const [activeProblemId, setActiveProblemId] = useState(null);
     const [totalcomments, setTotalComments] = useState(null);
     const [visibleCount, setVisibleCount] = useState(24);

     // 🔥 FETCH ONLY PUBLIC PROBLEMS
     useEffect(() => {
          const q = query(
               collection(db, 'problems'),
               where('visibility', '==', 'Public'),
               orderBy('createdAt', 'desc')
          );

          const unsubscribe = onSnapshot(
               q,
               (snapshot) => {
                    const list = snapshot.docs.map((doc) => ({
                         id: doc.id,
                         ...doc.data(),
                    }));

                    setProblems(list);
                    setLoading(false);
               },
               (error) => {
                    console.error('Fetch public problems error:', error);
                    setLoading(false);
               }
          );

          return () => unsubscribe();
     }, []);


     const itemsToshow = previewItems ? problems.slice(0, 9) : problems.slice(0, visibleCount);


     return (

          <>

               <SEO {...seoConfig.explore} />
               {!previewItems &&
                    <PageShapes />
               }

               <main className={`explore-page ${previewItems ? 'p-0' : ''}`}>

                    <Tabs>
                         {!previewItems &&
                              <section className="hero-section">
                                   <div className="container">
                                        <span className="badge">World's First Problems/Ideas Marketplace</span>

                                        <h1>
                                             Identify. Validate. <span>Solve.</span>
                                        </h1>

                                        <p>
                                             Explore real-world challenges shared by builders worldwide.
                                             Find startup ideas from validated pain points.
                                        </p>

                                        <div className="type-tags">
                                             <span className="tag admin"> {ideasBatch?.length || 0} Admin</span>
                                             <span className="tag idea"> {problems?.length || 0} Community</span>
                                        </div>

                                        <div className="search-bar d-none">
                                             <input type="text" placeholder="Search problems..." />
                                             <button>Search</button>
                                        </div>



                                   </div>
                              </section>
                         }


                         <section className="feed-section pb-5">
                              <div className='row'>
                                   <div className='col-12'>
                                        <TabList>
                                             <Tab>Admin </Tab>
                                             <Tab>Community</Tab>
                                        </TabList>
                                   </div>
                              </div>

                              <TabPanel>
                                   <AdminExplore loading={loading} previewItems={previewItems} />
                              </TabPanel>

                              <TabPanel>
                                   <div className='row row-gap-4'>

                                        {loading ? (
                                             <div className='col-12 text-center'>
                                                  <div style={{ padding: '20px' }}>
                                                       <Loading text="Loading..." />
                                                  </div>
                                             </div>
                                        ) : problems.length === 0 ? (
                                             <div className='col-12 text-center'>
                                                  <div style={{ padding: '20px' }}>
                                                       <Loading text="No public problems/Idea found ..." />
                                                  </div>
                                             </div>
                                        ) : (
                                             itemsToshow.map((item, i) => (
                                                  <div className={`col-md-${previewItems ? '4' : '3'}`} key={i}>

                                                       <div className={`explore-card ${item?.type === 'Problem' ? 'feature-problems' : 'feature-idea'}`}>

                                                            {/* USER */}
                                                            <div className="card-top">
                                                                 <div className="avatar">
                                                                      {item.userInitials || 'U'}
                                                                 </div>

                                                                 <div className="user-meta">
                                                                      <h4>{item.userName || 'Unknown'}</h4>
                                                                      <span>
                                                                           {formatTimeAgo(item.createdAt)} • {item.visibility}
                                                                      </span>
                                                                 </div>
                                                            </div>

                                                            {/* PROBLEM */}
                                                            <div className="card-body">
                                                                 <span className="cat-tag types"> {item?.type || 'Idea'} </span>
                                                                 <span className="cat-tag"> {item?.category || 'General'} </span>

                                                                 <p className='heading-font'> {item?.title}</p>
                                                                 <p className='shortIKj'> {item?.problem?.slice(0, 120)}...</p>
                                                            </div>

                                                            {/* <MembersPreview i={i} interestedCount={item.interestedCount} /> */}

                                                            <div className="card-actions">

                                                                 <LikeButton problemId={item.id} likes={item.likes || 0} />

                                                                 <button
                                                                      className="action-btn comment-btn"
                                                                      onClick={() => {
                                                                           setTotalComments(item?.comments)
                                                                           setActiveProblemId(item.id);
                                                                           setShowComments(true);
                                                                      }}
                                                                 >
                                                                      <Comment /> <span>{item?.comments || 0}</span>
                                                                 </button>

                                                                 <BookmarkButton problemId={item?.id} />

                                                                 <button onClick={() => shareTextOf(`${window.location.origin}/interested/${item?.id}`)} type='button' className="share-btn"> <Share /> </button>


                                                            </div>



                                                            {/* CTA */}
                                                            <div className="comment-input-area">
                                                                 <button
                                                                      className="interested-cta heading-font"
                                                                      onClick={() => {
                                                                           navigate(`/interested/${item.id}`);
                                                                      }}
                                                                 >
                                                                      I'm Interested
                                                                 </button>

                                                                 <p>
                                                                      Click <span>Interested</span> to view details and <br />
                                                                      <span> {item.interestedCount || 0} </span> interested users.
                                                                 </p>
                                                            </div>

                                                       </div>
                                                  </div>

                                             ))
                                        )}

                                        {!previewItems && visibleCount < problems.length && (
                                             <div className='col-12'>
                                                  <div className="col-12 text-center mt-4">
                                                       <button
                                                            className="view-more-btn"
                                                            onClick={() => setVisibleCount(prev => prev + 24)}
                                                       >
                                                            + {problems?.length - itemsToshow?.length || 0} View More
                                                       </button>
                                                  </div>
                                             </div>
                                        )}
                                   </div>

                              </TabPanel>



                         </section>


                         <section className="explore-end">
                              <div className="container">

                                   <div className="top">
                                        <h2>Explore Real Ideas & Problems</h2>
                                        <p>
                                             Discover ideas and real-world problems shared by people. Learn what others are building,
                                             what challenges they face, and how the community responds with feedback and solutions.
                                        </p>
                                   </div>

                                   <div className="grid">
                                        <div className="card">
                                             <h3>💡 Discover Ideas</h3>
                                             <p>
                                                  Browse creative ideas shared by users. Get inspired and understand what people are building.
                                             </p>
                                        </div>

                                        <div className="card">
                                             <h3>⚠️ Real Problems</h3>
                                             <p>
                                                  Explore real problems faced by users. These are actual pain points waiting for solutions.
                                             </p>
                                        </div>

                                        <div className="card">
                                             <h3>💬 Community Feedback</h3>
                                             <p>
                                                  See how people react with likes and comments. Learn what works and what doesn’t.
                                             </p>
                                        </div>

                                        <div className="card">
                                             <h3>🚀 Validate Faster</h3>
                                             <p>
                                                  Use real feedback to validate ideas before investing time, effort, or money.
                                             </p>
                                        </div>
                                   </div>

                                   <div className="cta">
                                        <h3>Have an Idea or Problem?</h3>
                                        <p>
                                             Share it with the community and get instant feedback, suggestions, and solutions.
                                        </p>

                                        <a href="/submit" className="btn">
                                             Submit Now
                                        </a>
                                   </div>

                              </div>
                         </section>

                    </Tabs>

                    <CommentsOffcanvas
                         show={showComments}
                         handleClose={() => setShowComments(false)}
                         problemId={activeProblemId}
                         totalcomments={totalcomments}
                    />
               </main>
          </>

     );
};

export default Explore;